import {
  GET_REVIEW_PROFILE,
  GET_REVIEW_PROFILE_FAIL,
  GET_REVIEW_PROFILE_SUCCESS,
  GET_REVIEWS,
  GET_REVIEWS_FAIL,
  GET_REVIEWS_SUCCESS,
  ADD_NEW_REVIEW,
  ADD_REVIEW_SUCCESS,
  ADD_REVIEW_FAIL,
  UPDATE_REVIEW,
  UPDATE_REVIEW_SUCCESS,
  UPDATE_REVIEW_FAIL,
  DELETE_REVIEW,
  DELETE_REVIEW_SUCCESS,
  DELETE_REVIEW_FAIL,
} from "./actionTypes"

export const getReviews = ({date='', query='',offset, page_size }) => ({
  type: GET_REVIEWS,
  payload: { date, offset, page_size,query },
})

export const getReviewsSuccess = reviews => ({
  type: GET_REVIEWS_SUCCESS,
  payload: reviews,
})

export const getReviewsFail = error => ({
  type: GET_REVIEWS_FAIL,
  payload: error,
})

export const addNewReview = (user,history) => ({
  type: ADD_NEW_REVIEW,
  payload: {user,history},
})

export const addReviewSuccess = user => ({
  type: ADD_REVIEW_SUCCESS,
  payload: user,
})  

export const addReviewFail = error => ({
  type: ADD_REVIEW_FAIL,
  payload: error,
})

export const updateReview = (review,history) => ({
  type: UPDATE_REVIEW,
  payload: {review,history},
})

export const updateReviewSuccess = user => ({
  type: UPDATE_REVIEW_SUCCESS,
  payload: user,
})

export const updateReviewFail = error => ({
  type: UPDATE_REVIEW_FAIL,
  payload: error,
})

export const deleteReview = user => ({
  type: DELETE_REVIEW,
  payload: user,
})

export const deleteReviewSuccess = user => ({
  type: DELETE_REVIEW_SUCCESS,
  payload: user,
})

export const deleteReviewFail = error => ({
  type: DELETE_REVIEW_FAIL,
  payload: error,
})

export const getReviewProfile = () => ({
  type: GET_REVIEW_PROFILE,
})

export const getReviewProfileSuccess = userProfile => ({
  type: GET_REVIEW_PROFILE_SUCCESS,
  payload: userProfile,
})

export const getReviewProfileFail = error => ({
  type: GET_REVIEW_PROFILE_FAIL,
  payload: error,
})
